import type { Locale } from '@/i18n/config'
import type { SupportedLocale } from '@openai/chatkit-react'

/**
 * Maps next-intl locale codes to ChatKit supported locale codes
 * ChatKit supports BCP 47 language tags, so we map simple codes appropriately
 * @param locale - Next-intl locale code
 * @returns ChatKit supported locale code
 */
export function mapLocaleToChatkitLocale(locale: Locale): SupportedLocale {
  const localeMap: Record<Locale, SupportedLocale> = {
    en: 'en',
    zh: 'zh',
    es: 'es',
    ja: 'ja',
    fr: 'fr',
    de: 'de',
    ko: 'ko',
    hi: 'hi',
    ar: 'ar',
    bn: 'bn',
    pt: 'pt',
    ru: 'ru',
    vi: 'vi',
    it: 'it',
    tr: 'tr',
    th: 'th',
  }

  return localeMap[locale] || 'en'
}
